const STORAGE_KEY = "tourist_panel_device_token";

export function getOrCreateTouristPanelDeviceToken(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length >= 16) {
      return existing;
    }
  } catch {
    // localStorage nicht verfügbar
  }
  const token = `${crypto.randomUUID().replace(/-/g, "")}${crypto.randomUUID().replace(/-/g, "").slice(0, 8)}`;
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Token nur für diese Sitzung nutzbar
  }
  return token;
}
